// src/views/apps/user/clearUserData.js
import store from '@/store'
import axios from '@axios'
import ability from '@/libs/acl/ability'
import { initialAbility } from '@/libs/acl/config'

const MANAGED_HEADER_KEY = 'Managed-User-id'

const safeCommit = (type, payload) => {
  try { store.commit(type, payload) } catch (_) {}
}

const safeRemove = (storage, key) => {
  try { storage.removeItem(key) } catch (_) {}
}

export const clearUserData = () => {
  // Account/user
  safeCommit('account/clearUser')
  safeCommit('account/clearAccountSettings')

  // Location
  safeCommit('location/deleteLocation')
  safeCommit('location/deleteLocations')

  // App features
  safeCommit('notification/DELETE_NOTIFICATION_DATA')
  safeCommit('calendar/DELETE_CALENDAR_DATA')

  // Point/hours
  safeCommit('point/setPoint', {})
  safeCommit('point/INIT_HOURS', {})

  // Wallet (if exists)
  safeCommit('wallet/RESET')

  // Managed user / impersonation
  safeCommit('user/unsetUserManaged')

  // Local/session storage
  safeRemove(localStorage, 'userData')
  safeRemove(localStorage, 'lat')
  safeRemove(localStorage, 'lng')
  safeRemove(sessionStorage, 'auth.returnTo')

  // Axios headers (auth + managed)
  try {
    axios.defaults.headers = axios.defaults.headers || {}
    axios.defaults.headers.common = axios.defaults.headers.common || {}
    delete axios.defaults.headers.common.Authorization
    delete axios.defaults.headers.common[MANAGED_HEADER_KEY]
    delete axios.defaults.headers.Authorization
    delete axios.defaults.headers[MANAGED_HEADER_KEY]
  } catch (_) {}

  // Reset abilities to guest baseline
  try { ability.update(initialAbility) } catch (_) {}
}
